export default __webpack_public_path__ + "60076c21686e60181d51270f580531f3.png";